import React from "react";
import Styles from "./AttendanceDetails.module.css";

const AttendanceDetails = ({ title = "", total = 0, statuses = [] }) => {
  return (
    <div className={Styles.AttendanceDetailsBox}>
      <div className={Styles.titleRow}>
        <span className={Styles.title}>{title}</span>
        <span className={Styles.total}>{total}</span>
      </div>
      <div className={Styles.AttendanceDetails}>
        {statuses.map((item, index) => (
          <div key={index} className={Styles.statusItem}>
            <span className={Styles.label}>{item.label}</span>
            <span className={Styles.value} data={`${item.label.toLowerCase()}`}>{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AttendanceDetails;
